// Единый грид сущностей. Собирает в одном месте то, что раньше повторялось в
// восьми списках: плотность, ключ строки, горизонтальная прокрутка и — главное —
// пагинация, синхронизированная с URL (переживает перезагрузку и работает в ссылках).
//
// Ховер строки берётся из темы antd (`Table.rowHoverBg`), а не из ручных
// onMouseEnter/onMouseLeave, как было в четырёх местах.
import type { ReactElement } from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';

import { useDataViewPagination } from '../dataview/useDataViewPagination.js';
import { TABLE_SORTER_TOOLTIP } from './list-styles.js';

export type EntityTableProps<T extends object> = Omit<TableProps<T>, 'size'> & {
  /** Данные строки; используется и для расчёта пагинации. */
  dataSource: readonly T[];
  /** Отключить пагинацию (короткие вложенные списки на карточках). */
  paginated?: boolean;
};

export function EntityTable<T extends object>({
  dataSource,
  paginated = true,
  pagination,
  rowKey = 'id',
  scroll,
  ...rest
}: EntityTableProps<T>): ReactElement {
  const urlPagination = useDataViewPagination(dataSource as T[]);

  return (
    <Table<T>
      showSorterTooltip={TABLE_SORTER_TOOLTIP}
      {...rest}
      size="small"
      rowKey={rowKey}
      dataSource={dataSource as T[]}
      scroll={scroll ?? { x: 'max-content' }}
      pagination={
        // Явный проп важнее; иначе — URL-пагинация, либо её отсутствие.
        pagination !== undefined ? pagination : paginated ? urlPagination.pagination : false
      }
    />
  );
}
